import { render } from "./SpinnerItem.vue?vue&type=template&id=0225e570&scoped=true"
import script from "./SpinnerItem.vue?vue&type=script&lang=js"
export * from "./SpinnerItem.vue?vue&type=script&lang=js"

import "./SpinnerItem.vue?vue&type=style&index=0&id=0225e570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225e570"]])

export default __exports__